import { Search } from 'lucide-react';
import NotificationsBell from './NotificationsBell';

export default function Topbar({ title, subtitle, actions }) {
  return (
    <header
      data-testid="ops-topbar"
      className="h-14 sticky top-0 z-30 bg-white border-b border-slate-200 flex items-center justify-between gap-4 px-6"
    >
      <div className="min-w-0 flex items-center gap-3">
        <h1 className="text-[15px] font-semibold text-slate-900 tracking-tight truncate" data-testid="ops-topbar-title">{title}</h1>
        {subtitle && <span className="text-[12px] text-slate-500 truncate hidden sm:inline">{subtitle}</span>}
      </div>
      <div className="flex items-center gap-2">
        {/* Global search placeholder */}
        <div className="hidden md:flex items-center gap-2 bg-slate-50 border border-slate-200 rounded-md px-2.5 h-8 w-64 text-[12px] text-slate-400" data-testid="ops-topbar-search">
          <Search size={13} />
          <input
            placeholder="Search (soon)"
            disabled
            className="bg-transparent outline-none flex-1 placeholder:text-slate-400 cursor-not-allowed"
          />
          <kbd className="text-[10px] text-slate-400 border border-slate-200 rounded px-1 py-0.5 leading-none">⌘K</kbd>
        </div>
        <NotificationsBell />
        {actions}
      </div>
    </header>
  );
}
